/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import {
    GraphQLObjectType as ObjectType,
    GraphQLString as StringType,
    GraphQLID as ID,
    GraphQLNonNull as NonNull,
} from 'graphql';


const RealisationType = new ObjectType({
    name: 'Realisation',
    description: 'Cet objet represente une realisation',
    fields: () => ({
        id: {
            type: new NonNull(ID),
            description: 'Le id de la realisation',
            resolve: (root) => root.id
        },
        slug: {
            type: StringType,
            description: 'Le slug de la realisation',
            resolve: (root) => root.slug
        },
        title: {
            type: StringType,
            description: 'Le titre de la realisation',
            resolve: (root) => root.title.rendered
        },
        content: {
            type: StringType,
            description: 'Le content de la realisation',
            resolve: (root) => root.content.rendered
        },
        excerpt: {
            type: StringType,
            description: 'Extrait de la realisation',
            resolve: (root) => root.acf.extrait_realisation_accueil
        },
        thumb1: {
            type: StringType,
            description: 'Image de la realisation 400 x 227',
            resolve: (root) => root.acf.thumbnail_400x227.url
        },
        thumb2: {
            type: StringType,
            description: 'Image de la realisation 600 x 340',
            resolve: (root) => root.acf.thumbnail_600x340.url
        },
        thumb3: {
            type: StringType,
            description: 'Image de la realisation 750 x 425',
            resolve: (root) => root.acf.thumbnail_750x425.url
        },
        logo: {
            type: StringType,
            description: 'Logo de la realisation',
            resolve: (root) => root.acf.logo_realisation.url
        },
        banniere: {
            type: StringType,
            description: 'Banniere de la realisation',
            resolve: (root) => root.acf.banniere_realisation.url
        },
        objectif: {
            type: StringType,
            description: 'Section objectif et moyen de la realisation',
            resolve: (root) => root.acf.section_objectif_et_moyen
        },
        statistique: {
            type: StringType,
            description: 'Section statistiques de la realisation',
            resolve: (root) => root.acf.section_statistiques
        },
        lienSite: {
            type: StringType,
            description: 'Site de la realisation',
            resolve: (root) => root.acf.lien_realisation
        },
        libelleBtnSite: {
            type: StringType,
            description: 'Site de la realisation',
            resolve: (root) => root.acf.libelle_lien_realisation
        },
    }),
});

export default RealisationType;



// WEBPACK FOOTER //
// ./data/types/RealisationType.js